<template>
  <div class="tw-rounded-lg tw-p-6 tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-border">
    <div class="tw-text-blue tw-text-4xl tw-font-medium tw-text-center">
      <slot name="stat" />
    </div>
    <div class="tw-flex tw-gap-1 tw-text-center tw-justify-center tw-text-grey-dark tw-items-center">
      <slot name="title" />
    </div>
  </div>
</template>